import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { IDiscountBannerTheme } from "app/components/discountCampaign/DiscountBanner/types";

export const DISCOUNT_BANNER_HEIGHT = 54;

export const DiscountBannerContent = styled(Flex)<{
    isSticky: boolean;
    bannerTheme: IDiscountBannerTheme;
    hasButton: boolean;
}>`
    position: relative;
    z-index: 1;
    align-items: center;
    justify-content: ${({ hasButton }) => (hasButton ? "space-between" : "center")};
    min-height: ${DISCOUNT_BANNER_HEIGHT}px;
    font-size: 1rem;
    padding: 0 24px;
    color: ${({ bannerTheme }) => bannerTheme.color};
    background: ${({ bannerTheme }) => bannerTheme.background};

    ${({ isSticky }) =>
        isSticky &&
        css`
            position: sticky;
            top: 0;
        `};
`;

export const DiscountBannerContentGroup = styled(Flex)<{ $hasButton?: boolean }>`
    align-items: center;
    gap: 10px;
    flex: ${({ $hasButton }) => ($hasButton ? 1 : "none")};
    justify-content: ${({ $hasButton }) => ($hasButton ? "flex-start" : "center")};
`;

export const DiscountBannerTitle = styled.span`
    color: ${colorsPalettes.carbon[0]};
    text-align: center;
    font-feature-settings:
        "liga" off,
        "clig" off;
    font-size: 23.863px;
    font-family: "DM Sans", sans-serif;
    font-style: normal;
    font-weight: bold;
    line-height: 23.863px;
    padding-right: 24px;
`;

export const DiscountBannerText = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[0])};
    > span {
        ${setFontVariant("h5_2", colorsPalettes.orange[300])};
    }
`;

export const DiscountBannerCoupon = styled.span`
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon[0])};
`;

export const DiscountBannerSuffixWithCounter = styled(Flex)`
    align-items: center;
    gap: 4px;
`;

export const DiscountBannerCtaButton = styled.button<{ $width?: number; $bannerTheme: IDiscountBannerTheme }>`
    ${({ $bannerTheme }) => setFontVariant("button", $bannerTheme.ctaButtonColor ?? $bannerTheme.counterColor)};
    background: ${colorsPalettes.carbon[0]};
    border: none;
    border-radius: 69px;
    padding: 8px 16px;
    cursor: pointer;
    width: ${({ $width }) => ($width != null ? `${$width}px` : "fit-content")};
`;

export const CloseButton = styled(IconButton)<{ iconColor?: string }>`
    .SWReactIcons svg {
        path {
            fill: ${({ iconColor }) => `${iconColor} !important`};
        }
    }
`;
